import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class UserCookiesService {

  showCookies = new EventEmitter<boolean>();
  constructor() { }

  showCookiesRules(show : boolean) {
    this.showCookies.emit(show)
  }

}
